const money = new Map<string, Intl.NumberFormat>()

/** Medusa v2 amounts are major units (49.99). */
export function formatMoney(amount: number | null | undefined, currency = "usd") {
  if (amount == null) return "—"
  const code = currency.toUpperCase()
  if (!money.has(code)) money.set(code, new Intl.NumberFormat("en-US", { style: "currency", currency: code }))
  return money.get(code)!.format(amount)
}

export function formatDate(iso: string | Date | null | undefined, withTime = true) {
  if (!iso) return "—"
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    ...(withTime ? { hour: "numeric", minute: "2-digit" } : {}),
    timeZone: "America/New_York",
  }).format(new Date(iso))
}

export function relativeTime(iso: string | null | undefined) {
  if (!iso) return "never"
  const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000)
  if (s < 60) return "just now"
  if (s < 3600) return `${Math.floor(s / 60)}m ago`
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`
  return `${Math.floor(s / 86400)}d ago`
}

export function fullName(p: { first_name?: string | null; last_name?: string | null } | null | undefined) {
  return [p?.first_name, p?.last_name].filter(Boolean).join(" ")
}
